import React, { useCallback, useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { FooterMenu, getFooterMenu } from "../../../constants/Qmenu";
import AIcon from "./assets/AIcon.svg?react";
import Bot from "./assets/Bot.svg?react";
import Bot2 from "./assets/Bot2.svg?react";
import CallIcon from "./assets/CallIcon.svg?react";
import Facebook from "./assets/Facebook.svg?react";
import Ghost from "./assets/Ghost.svg?react";
import Insta from "./assets/Insta.svg?react";
import Musix from "./assets/Musix.svg?react";
import XIcon from "./assets/XIcon.svg?react";
import YouTube from "./assets/YouTube.svg?react";
import FooterMenuList from "./components/FooterMenuList";
import * as S from "./style";

import Dark_AIcon from "./assets/Dark-AIcon.svg?react";
import Dark_Bot from "./assets/Dark-Bot.svg?react";
import Dark_Bot2 from "./assets/Dark-Bot2.svg?react";
import Dark_CallIcon from "./assets/Dark-CallIcon.svg?react";
import Dark_Facebook from "./assets/Dark-Facebook.svg?react";
import Dark_Ghost from "./assets/Dark-Ghost.svg?react";
import Dark_Insta from "./assets/Dark-Insta.svg?react";
import Dark_Musix from "./assets/Dark-Musix.svg?react";
import Dark_XIcon from "./assets/Dark-XIcon.svg?react";
import Dark_YouTube from "./assets/Dark-YouTube.svg?react";

import Currency from "./assets/Currency.svg?react";
import DarkMode from "./assets/DarkMode.svg?react";
import Global from "./assets/Global.svg?react";

import Dark_Currency from "./assets/Dark-Currency.svg?react";
import Dark_DarkMode from "./assets/Dark-DarkMode.svg?react";
import Dark_Global from "./assets/Dark-Global.svg?react";

import { ThemeContext } from '@/theme/ThemeProvider';
import CurrencyModal from "@app/organisms/Footer/CurrencyChange/CurrencyModal";
import LanguageModal from "@app/organisms/Header/BtnLanguageChange/LanguageModal";
import { CModal } from "@components/Common";
import { media } from "../../../../styles/Qtheme";
import { MobileCalVW, TabletCalVW, useIsTablet } from "../../../../utils/CalVW";
import { useTranslation } from 'react-i18next';

function Footer({themeToggler}:any) {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isDefault, setIsDefault] = useState(true);
  const {  isDarkMode, toggleTheme, } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  const { t, i18n } = useTranslation();
  const [footerMenuItems, setFooterMenuItems] = useState(getFooterMenu());

  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal && setShowModal(false);
  const openModal = () => {
    setShowModal(true)
  };


  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const closeCurrencyModal = () => setShowCurrencyModal && setShowCurrencyModal(false);
  const openCurrencyModal = () => {
    setShowCurrencyModal(true)
  };

  const IsTablet = useIsTablet();

  const IconList = [
    Facebook,
    Insta,
    Bot,
    Musix,
    XIcon,
    CallIcon,
    YouTube,
    AIcon,
    Bot2,
    Ghost,
  ];

  const DarkIconList = [
    Dark_Facebook,
    Dark_Insta,
    Dark_Bot,
    Dark_Musix,
    Dark_XIcon,
    Dark_CallIcon,
    Dark_YouTube,
    Dark_AIcon,
    Dark_Bot2,
    Dark_Ghost,
  ];

  const handleToggleMenu = useCallback((menu: string) => {
    if (activeMenu === menu) {
      setActiveMenu(null);
    } else {
      setActiveMenu(menu);
    }
  }, [activeMenu]);

  useEffect(() => {
    if (activeMenu) {
      setIsDefault(false);
    } else {
      setIsDefault(true);
    }
  }, [activeMenu]);

  useEffect(() => {
    // i18n 언어가 변경될 때마다 메뉴를 업데이트
    setFooterMenuItems(getFooterMenu());
  }, [i18n.language]);

  return (
    <S.Container>
      <S.FooterTopContainer>
        {!IsTablet && (
          <LeftSide>
            <CommuWrapper>
              <CommuLabel>{t("community")}</CommuLabel>
              <CommuContents>
                {theme === "light"
                  ? DarkIconList.map((icon, index) => <ItemIconSVG as={icon} key={`dark-icon-${index}`} />)
                  : IconList.map((icon, index) => <ItemIconSVG as={icon} key={`icon-${index}`} />)}
              </CommuContents>
            </CommuWrapper>
            <UtilWrapper>
              <UtilRow onClick={openModal}>
                <UtilIcon as={theme === "light" ? Dark_Global : Global}/>
                <UtilText>{t("language")}</UtilText>
              </UtilRow>

              <CModal
                visible={showModal}
                onClose={closeModal}
                bgColor={'transparent'}>
                <LanguageModal closeModal={closeModal} />
              </CModal>

              <UtilRow onClick={openCurrencyModal}>
                <UtilIcon as={theme === "light" ? Dark_Currency : Currency}/>
                <UtilText>{t("currency")}</UtilText>
              </UtilRow>

              <CModal
                visible={showCurrencyModal}
                onClose={closeCurrencyModal}
                bgColor={'transparent'}>
                <CurrencyModal closeModal={closeCurrencyModal} />
              </CModal>

              <UtilRow onClick={() => themeToggler()}>
                <UtilText>{t("theme")}</UtilText>
                <UtilIcon as={theme === "light" ? Dark_DarkMode : DarkMode}/>
              </UtilRow>
            </UtilWrapper>
          </LeftSide>
        )}

        <S.FooterMenuBox>
          {footerMenuItems.map((menu, index) => (
            <FooterMenuList
              key={`footer-menu-${index}`}
              isDefault={isDefault}
              activeMenu={activeMenu}
              handleToggleMenu={handleToggleMenu}
              menu={menu}
            />
          ))}
        </S.FooterMenuBox>
        {/*<S.IconContainer>*/}
        {/*	<button>*/}
        {/*		<img src="/images/facebook-light.png" alt="" />*/}
        {/*	</button>*/}
        {/*	<button>*/}
        {/*		<img src="/images/insta-light.png" alt="" />*/}
        {/*	</button>*/}
        {/*	<button>*/}
        {/*		<img src="/images/ficon-light.png" alt="" />*/}
        {/*	</button>*/}
        {/*</S.IconContainer>*/}
      </S.FooterTopContainer>

      {IsTablet && (
        <CommuWrap>
          <CommuTitle>{t("community")}</CommuTitle>
          <MobileCommuContents>
            {theme === "light"
              ? DarkIconList.map((icon) => <ItemIconSVG as={icon}/>)
              : IconList.map((icon) => <ItemIconSVG as={icon}/>)}
          </MobileCommuContents>
        </CommuWrap>
      )}

      <S.FooterBottomContainer>
        <p>
          <span>BYNOVA</span> {t("copyright")} © 2013-2025.
        </p>
      </S.FooterBottomContainer>
    </S.Container>
  );
}

export default React.memo(Footer);

const LeftSide = styled.div`
    margin-right: 103px;
`;

const CommuWrapper = styled.div`
    margin-bottom: 52px;
`;

const UtilWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22.5px;
`;

const UtilRow = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
`;

const UtilText = styled.div`
    font-size: 14px;
    font-weight: 500;
    line-height: 16.71px;
    font-family: "Pretendard", sans-serif;
    color: ${({theme}) => theme.text};
`;

const UtilIcon = styled.svg`
    width: 24px;
    height: 24px;
    cursor: pointer;
`;


const CommuLabel = styled.div`
    font-size: 16px;
    line-height: 19.09px;
    font-family: "Pretendard", sans-serif;
    font-weight: 600;
    color: ${({theme}) => theme.text};
    margin-bottom: 22px;
`;

const CommuContents = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4열 */
    grid-template-rows: repeat(3, auto); /* 3행 */
    gap: 24px 30px; /* 세로 간격 24px, 가로 간격 30px */
`;

const ItemIconSVG = styled.svg`
    width: 30px;
    height: 30px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
`;

const CommuWrap = styled.div`
    width: 1200px;
    max-width: 1750px;
    padding: 55px 20px 30px;
    margin: 0 auto;

    @media ${media.desktop} {
        padding: 10px ${TabletCalVW(20)};
    }

    @media ${media.mobile} {
        padding: 25px ${MobileCalVW(16)} 0 ${MobileCalVW(16)};
    }
`

const CommuTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 19.09px;
    font-family: "Pretendard", sans-serif;
    color: ${({theme}) => theme.text};
`

const MobileCommuContents = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr); /* 4열 */
    grid-template-rows: repeat(2, auto); /* 3행 */
    gap: 20px 14px; /* 세로 간격 24px, 가로 간격 30px */


    @media ${media.desktop} {
        padding: 28px 0;
        width: 400px;
    }

    @media ${media.mobile} {
        width: ${MobileCalVW(250)};
    }
`;
